const settings = {
  dashboardSettings: {},
  newDealNotificationRecipients: [],
  approvedDealNotificationRecipients: [],
  rejectedDealNotificationRecipients: [],
  carbonCopyDealNotificationRecipients: [],
  headCountSettings: {},
  payRateSettings: {},
  revenueYTD: null,
  zohoIntegrationEnabled: {},
  finalizedContractNotificationSettings: { isActive: false, recipients: [] },
  documentSettings: {},
  beginningOfWeek: null,
  scheduledJobsSettings: {
    assignmentsAboutToEnd: {
      isActive: false
    },
    assignmentsPastEndDate: {
      isActive: false
    },
    timeSheetNoTimeEnteredNotification: {
      isActive: false
    },
    timeSheetNoTimeEnteredReminder: {
      isActive: false
    }
  }
}

export default () => Object.assign({}, settings)
